import type {ISbStoryData} from 'storyblok-js-client';
import {getCommonStoryParams} from '~/storyblok/api/options';
import type {PageTypeGasStationStoryblok} from '~/storyblok/types';
import useThrottledFetchingWithCache from '~/composables/useThrottledFetchingWithCache';
import {getBranchStoryblokSlug} from '~/utils/branch';

export const useStoryblokGasStation = defineStore('storyblokGasStation', () => {
	const {$storyblokApi, runWithContext} = useNuxtApp();
	const cache = useThrottledFetchingWithCache<ISbStoryData<PageTypeGasStationStoryblok>>();
	let abort: AbortController['abort'] | null = null;

	function fetch(hm: string) {
		return cache.fetchItems(hm, async () => {
			abort?.();
			const {signal, abort: newAbort} = abortController();
			if (import.meta.client) {
				abort = newAbort;
			}

			const {data} = await $storyblokApi.get(
				'stories',
				{
					...runWithContext(getCommonStoryParams),
					starts_with: getBranchStoryblokSlug(hm, 'sluzby'),
					content_type: 'PageTypeGasStation',
					per_page: 1,
				},
				{signal},
			);

			return data.stories[0];
		});
	}

	return {fetch};
});
